module.exports = __webpack_public_path__ + "static/media/ilocalbox-logo.27108550.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/login/ilocalbox-logo.svg
// module id = 13361
// module chunks = 0